<template>

<div class="col-md-4 pr-0">
    <div class="carrinho" v-bind:class="{ show: ocultarCarrinho }">

      <div class="carrinhoContent c-bg c-txt ">

        <div class="d-flex flex-column">
          <div class="mb-4 d-flex justify-content-between">
            <h3 class="c-hn"><i class="fas fa-shopping-cart"></i> Carrinho de compras</h3>
            <button v-if="ocultarCarrinho" type="button" class="close" v-on:click="mostrarCarrinho">
                <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="d-flex flex-row justify-content-between my-2 pb-1 cart--item"
            v-for="(produto, index) in produtosSelecionados" :key="index"
          >

            <template v-if="produto.tipo==1">

              <div>
                <div><h4 class="mb-0" role="button" v-on:click="editarItemDoCarrinho(index)">{{produto.produto.nome}}</h4> </div>
                <div>
                  <template v-if="produto.produto.grupoopcional">
                    <template v-if="produto.produto.grupoopcional.multipla_escolha==1">
                      <span class="badge badge-pill badge-danger m-1"
                        v-for="(opcional, index) in produto.opcionais" :key="index"
                      >
                        +{{opcional.nome}}
                      </span>
                    </template>
                    <template v-else>
                      <span class="badge badge-pill badge-danger m-1" >
                        {{produto.opcionais.nome}}
                      </span>
                    </template>
                  </template>

                  <p>{{produto.obs}}</p>
                </div>
              </div>
              <div style="min-width: 90px; text-align: center;">
                <div>

                  <div class="cart--item--qtarea" v-if="produto.produto.unidade_de_medida=='unidade'">

                    <button class="cart--item-qtmenos"
                      v-on:click="
                        produto.quantidade>1
                        ? produto.quantidade -= 1
                        :removerProduto(index), alterarQuantidade()"
                      >-</button>

                    <div class="cart--item--qt">{{produto.quantidade}}</div>

                    <button class="cart--item-qtmais" 
                        v-on:click="produto.quantidade += 1, alterarQuantidade()"
                      >+</button>
                  </div>

                  <div class="cart--item--qtarea" v-if="produto.produto.unidade_de_medida=='kg'">
                    <div class="cart--item--qt">{{produto.quantidade}} Kg</div>
                  </div>

                </div>
                <div class="my-2">
                  <h5>R$ {{formatarMoeda(setarValor(produto))}}</h5>
                </div>
              </div>

            </template>

            <template v-else-if="produto.tipo==2">

              <div>
                <div><h4 class="mb-0">Pizza {{produto.tamanho.nome}}</h4></div>
                <div>
                  <template
                    v-if="!(Object.keys(produto.borda).length === 0 && produto.borda.constructor === Object)"
                  >
                    <p class="m-0">
                      Borda:
                      <span class="badge badge-pill badge-danger m-1" >
                        {{produto.borda.nome}}
                      </span>
                    </p>
                  </template>
                  <template
                    v-if="!(Object.keys(produto.massa).length === 0 && produto.massa.constructor === Object)"
                  >
                  <p class="m-0">
                    Massa:
                    <span class="badge badge-pill badge-danger m-1" >
                       {{produto.massa.nome}}
                    </span>
                  </p>
                  </template>
                  <template v-if="produto.sabores">
                    <p class="m-0">
                      Sabores:
                      <span
                        v-for="sabor in produto.sabores"
                        :key="sabor.id"
                        class="badge badge-pill badge-danger m-1"
                      >
                        {{sabor.nome}}
                      </span>
                    </p>
                  </template>

                  <p>{{produto.obs}}</p>
                </div>
              </div>
              <div style="min-width: 90px; text-align: center;">
                <div>

                  <div class="cart--item--qtarea">
                    <button class="cart--item-qtmenos"
                      v-on:click="
                        produto.quantidade>1
                        ? produto.quantidade -= 1
                        :removerProduto(index), alterarQuantidade()"
                      >-</button>
                    <div class="cart--item--qt">{{produto.quantidade}}</div>
                    <button class="cart--item-qtmais"  v-on:click="produto.quantidade += 1, alterarQuantidade()" >+</button>
                  </div>

                </div>
                <div class="my-2">
                  <h5>R$ {{formatarMoeda(setarValor(produto))}}</h5>
                </div>
              </div>

            </template>


            <template v-else-if="produto.tipo==3">

              <div>
                <div><h4 class="mb-0">{{produto.nome}}</h4></div>
                <div v-for="(pizza, index) in produto.produtos" :key="index" >
                  <h5>- Pizza {{index+1}}</h5>
                  <template
                    v-if="!(Object.keys(pizza.borda).length === 0 && pizza.borda.constructor === Object)"
                  >
                    <p class="m-0">
                      Borda:
                      <span class="badge badge-pill badge-danger m-1" >
                        {{pizza.borda.nome}}
                      </span>
                    </p>
                  </template>
                  <template
                    v-if="!(Object.keys(pizza.massa).length === 0 && pizza.massa.constructor === Object)"
                  >
                  <p class="m-0">
                    Massa:
                    <span class="badge badge-pill badge-danger m-1" >
                       {{pizza.massa.nome}}
                    </span>
                  </p>
                  </template>
                  <template v-if="pizza.sabores">
                    <p class="m-0">
                      Sabores:
                      <span
                        v-for="sabor in pizza.sabores"
                        :key="sabor.id"
                        class="badge badge-pill badge-danger m-1"
                      >
                        {{sabor.nome}}
                      </span>
                    </p>
                  </template>

                  <template v-if="pizza.adicionais">
                    <p class="m-0">
                      <span
                        v-for="adicional in pizza.adicionais"
                        :key="adicional.id"
                        class="badge badge-pill badge-danger m-1"
                      >
                        {{adicional.nome}} + R$ {{adicional.valor}}
                      </span>
                    </p>
                  </template>

                  <p>{{pizza.obs}}</p>
                </div>
              </div>
              <div style="min-width: 90px; text-align: center;">
                <div>

                  <div class="cart--item--qtarea">
                    <button class="cart--item-qtmenos"
                      v-on:click="
                        produto.quantidade>1
                        ? produto.quantidade -= 1
                        :removerProduto(index), alterarQuantidade()"
                      >-</button>
                    <div class="cart--item--qt">{{produto.quantidade}}</div>
                    <button class="cart--item-qtmais"  v-on:click="produto.quantidade += 1, alterarQuantidade()" >+</button>
                  </div>

                </div>
                <div class="my-2">
                  <h5>R$ {{formatarMoeda(setarValor(produto))}}</h5>
                </div>
              </div>

            </template>


          </div>

          <div class="d-flex flex-column" v-if="produtosSelecionados.length > 0">

              <button v-if="produtosSelecionados.length > 0" class="btn btn-secondary btn-sm" v-on:click="limpar()" >Limpar Carrinho</button>


              <div class="d-flex flex-row justify-content-between my-4 pb-1">
                <div>
                  <h4>Valor Total:</h4>
                </div>
                <div>
                  <h3 class="c-hn">R$ {{formatarMoeda(valorTotalComp)}}</h3>
                </div>
              </div>

              <button class="btn c-btn" v-on:click="finalizarCompra()"  >FINALIZAR COMPRA</button>

          </div>
          <div v-else>
            <h4>Carrinho Vazio</h4>
            <p>Escolha os Produtos</p>
          </div>


        </div>

      </div>




    </div>

    <div class="btn_carrinho hide " v-if="!ocultarCarrinho">
        <button v-on:click="mostrarCarrinho"  class="btn c-btn"><i class="fas fa-shopping-cart"> </i> (R$ {{formatarMoeda(valorTotalComp)}}) </button>
    </div>

</div>


</template>

<script>
import Cookie from "js-cookie";
export default {

  data () {
    return {
      ocultarCarrinho: false,
      produtosSelecionados: [],
      produto_ativo: {},
      valorTotal:0,


    }
  },

  methods: {
    mostrarCarrinho: function () {
      this.ocultarCarrinho = !this.ocultarCarrinho
    },

    atualizarLista(){
      let obj1 = JSON.parse(JSON.stringify(this.selectedProducts));
      this.produtosSelecionados = obj1
    },

    removerProduto(index) {
      this.$store.dispatch('removerProduto', index).then();
      this.atualizarLista();
    },

    limpar() {
      this.$store.dispatch('limparProdutos').then();
      this.atualizarLista();
    },

    modalAddCarrinho(produto){
        this.produto_ativo = produto;
        $('#addCarrinho').modal('show');
    },

     async editarItemDoCarrinho(item){
        let obj1 = JSON.parse(JSON.stringify(item));

        await this.$store.dispatch('editarProdutoCarrinho', obj1).then();
        await this.$store.dispatch('showModalAddCarrinho').then();
        $('#addCarrinho').modal('show');
    },

    setarValor(item) {

      if (item.tipo==1) {
          let valorProduto = 0;
          let valorOpcional = 0;
          let valorAdicional = 0;
          let valorEtapas = 0;

          if (item.produto.promocao) {
              valorProduto += parseFloat(item.produto.promocao.valor);
          }else{
              valorProduto += parseFloat(item.produto.valor);
          }

          if (item.produto.grupoopcional) {
            if (item.produto.grupoopcional.multipla_escolha==1) {
                  for (let index = 0; index < item.opcionais.length; index++) {
                      valorOpcional += parseFloat(item.opcionais[index].valor)
                  }
              }else{
                  if (item.opcionais.valor) {
                      valorOpcional += parseFloat(item.opcionais.valor)
                  }else{
                      valorOpcional += 0
                  }
              }

          }


          /* for (let index = 0; index < item.opcionais.length; index++) {
              valorOpcional += parseFloat(item.opcionais[index].valor)
          } */

          for (let index = 0; index < item.adicionais.length; index++) {
              valorAdicional += parseFloat(item.adicionais[index].valor)
          }

          for (let index = 0; index < item.etapas.length; index++) {
                valorEtapas += parseFloat(item.etapas[index].pivot.valor)
            }

        return item.quantidade*(valorProduto+valorOpcional+valorAdicional+valorEtapas)

        }else if(item.tipo==2){

          let valorTotalSabores = parseFloat(0);
          let valorBorda = parseFloat(item.borda.valor??0);
          let valorMassa = parseFloat(item.massa.valor??0);
          let valorAdicional = 0;
          let valorSabor = 0;

          for (let index = 0; index < item.sabores.length; index++) {

            if (item.sabores[index].promocao) {
                valorTotalSabores += parseFloat(item.sabores[index].promocao.valor);
            }else{
                valorTotalSabores += parseFloat(item.sabores[index].valor)
            }

          }

          if (item.sabores.length>0) {
              valorSabor = valorTotalSabores/item.sabores.length;
          }

          for (let index = 0; index < item.tamanho.adicionais.length; index++) {
              valorAdicional += parseFloat(item.tamanho.adicionais[index].valor)
          }

          return item.quantidade*(valorSabor+valorBorda+valorMassa+valorAdicional)

        }else if(item.tipo==3){


          let valorPizza = parseFloat(item.valor);
          let valorTotal = parseFloat(0);
          let valorAdicionais = parseFloat(0);

          for (let index = 0; index < item.produtos.length; index++) {
              valorTotal += parseFloat(item.produtos[index].borda.valor??0);
              valorTotal += parseFloat(item.produtos[index].massa.valor??0);

              item.produtos[index].adicionais.forEach(adicional => {
                    valorAdicionais += parseFloat(adicional.valor||0);
                });
          }

          return item.quantidade*(valorPizza+valorTotal+valorAdicionais);

        }

    },

    formatarMoeda(valor){
      return valor.toFixed(2).replace(".",",")
    },

    adicionarQuantidade(qt) {
      qt  = qt+1
    },

    alterarQuantidade(){
      let obj1 = JSON.parse(JSON.stringify(this.produtosSelecionados));

      this.$store.dispatch('atualizarProdutos', obj1).then();
    },

    async finalizarCompra(){

      if (this.logado) {
        this.ocultarCarrinho = false;
        // this.mostrarCarrinho();

        await this.$store.dispatch('showModalFinalizarCompra').then();
        $('#modalFinalizarCompra').modal('show')

      }else{
        // this.mostrarCarrinho();
        this.ocultarCarrinho = false;
        Cookie.set('proximaPagina', 'finalizarCompra' );
        await this.$store.dispatch('showModalLogin').then();
        $('#modalLogin').modal('show');
      }
    },



  },

  watch: {
    selectedProducts: function () {
        this.atualizarLista();
    },
    aleatorio: function () {
        this.atualizarLista();
    },
  },

  computed: {
    selectedProducts() {
      return this.$store.state.produtosSelecionados.main;
    },

    aleatorio(){
      return this.$store.state.produtosSelecionados.valorAleatorio;
    },


    valorTotalComp(){

      let valorProduto = 0;

      for (let index = 0; index < this.produtosSelecionados.length; index++) {
        valorProduto += this.setarValor(this.produtosSelecionados[index])
      }
      return valorProduto;
    },

    logado() {

      if (JSON.stringify(this.$store.state.perfil.main)==='{}') {
        return false
      }else{
        return true
      }
    },





  },

  mounted(){
    this.atualizarLista()
  }

}



</script>

<style>



.hide{
  display: none;
}

.carrinho{
  border-radius: 15px;
  position: sticky;
  top: 0;
  z-index: 11;
}

.carrinho h3 {
  text-shadow: -1px 1px 1px black;
}

.cart--item{
  border-bottom: 1px solid #000;
}

.cart--item--qtarea {
    display: inline-flex;
    background-color: #EEE;
    border-radius: 10px;
    height: 30px;
  }

  .cart--item--qtarea button {
    border: 0;
    background-color: transparent;
    font-size: 17px;
    outline: 0;
    cursor: pointer;
    padding: 0px 10px;
    color: #333;
  }

  .cart--item--qt {
    line-height: 30px;
    font-size: 12px;
    font-weight: bold;
    padding: 0px 5px;
    color: #000;
  }

  .close{
    font-size: 2rem;
    color: red;
  }

  .carrinhoContent {
      padding: 20px;
      border-radius: 15px;
  }


@media only screen and (max-width: 780px) {

  .btn_carrinho{
    display: block;
    position: fixed;
    bottom: 20px;
    right: 20px;
    z-index: 100;
  }

  .carrinho {
        display: none;
        position:fixed;
        left: 0;
        top:0;
        transition: all ease .9s;
        width: 100%;
        height: 100%;
        overflow: auto;
        background-color: rgb(0,0,0);
        background-color: rgba(0,0,0,0.4);
    }

    .carrinhoContent {
        position:relative;
        margin: 5%;
        box-shadow: 0 4px 10px 0 rgb(0 0 0 / 20%), 0 4px 20px 0 rgb(0 0 0 / 19%);
    }

    .show{
      display: block;
    }




}

</style>
